module.exports = __webpack_public_path__ + "54cf98f5/img/saly-icon.39e12342.jpg";